import React, { useEffect, useState } from 'react';
import styles from './businesses.module.scss';
import { useNavigate } from 'react-router-dom';
import { AppLinks } from 'app/router/consts/app-links.enum';
import { getOwnerBusinesses, MiniBusinessCard } from 'features';
import { IBusinessInfoDto } from 'shared/api/business/interfaces/business-info-dto.interface';
import { Loading } from 'pages/loading/ui/loading.page';

export const Businesses: React.FC = () => {
  const [businesses, setBusinesses] = useState<IBusinessInfoDto[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchBusinesses = async () => {
    try {
      const result = await getOwnerBusinesses();
      setBusinesses(result);
    } catch (error) {
      // error silently handled — empty state shown when businesses.length === 0
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBusinesses();
  }, []);

  useEffect(() => {
    if (!loading && businesses.length === 0) {
      navigate(AppLinks.BusinessRegistrationLink + '?onboarding=true', {
        replace: true,
      });
    }
  }, [loading, businesses, navigate]);

  if (loading) {
    return <Loading />;
  }

  const handleCreateButtonClick = () => {
    navigate(AppLinks.BusinessRegistrationLink);
  };

  return (
    <div className={styles.businesses_component}>
      <div className={styles.businesses_component__title}>Бизнесы</div>
      <div className={styles.businesses_component__content}>
        <div className={styles.content__cards}>
          {businesses.map((business) => (
            <MiniBusinessCard
              key={business.id}
              cardInfo={business}
            ></MiniBusinessCard>
          ))}
        </div>
        <div
          className={styles.content__create_button}
          onClick={handleCreateButtonClick}
        >
          <div className={styles.create_button__line_w}></div>
          <div className={styles.create_button__line_h}></div>
        </div>
      </div>
    </div>
  );
};
